// AdminDynamicEntry.jsx
import React, { useState } from "react";
import AdminHeader from "./AdminHeader"; //AdminHeader is an external component in the same directory (./AdminHeader.jsx).
import API_BASE_URL from "./api"; //API_BASE_URL is imported from a local file (./api.js) that likely contains the base URL for the backend API. This allows for easy configuration of the API endpoint across the application.
function genId() {
  return Math.random().toString(36).slice(2, 9);
}

const defaultSections = [
  // Notification Number
  {
    id: genId(),
    title: "Notification No",
    rows: [
      {
        id: genId(),
        key: "Notification_No",
        value: "",
        type: "text"
      }
    ]
  },

  // Important Dates
  {
    id: genId(),
    title: "Important Dates",
    rows: [
      {
        id: genId(),
        key: "Application_Start_Date",
        value: "",
        type: "date"
      },
      {
        id: genId(),
        key: "Application_Last_Date",
        value: "",
        type: "date"
      },
      {
        id: genId(),
        key: "Advertisement_Released_Date",
        value: "",
        type: "date"
      },
      {
        id: genId(),
        key: "Exam_Date",
        value: "",
        type: "date"
      },
      {
        id: genId(),
        key: "Interview_Date",
        value: "",
        type: "date"
      },
      {
        id: genId(),
        key: "Result_Date",
        value: "",
        type: "date"
      }
    ]
  },

  // Job Type
  {
    id: genId(),
    title: "Job Type",
    rows: [
      {
        id: genId(),
        key: "Permanent_Contractual",
        value: "Permanent",
        type: "select",
        options: ["Permanent", "Contractual"]
      }
    ]
  },

  // Form Mode
  {
    id: genId(),
    title: "Form Mode",
    rows: [
      {
        id: genId(),
        key: "Online_Offline",
        value: "Online",
        type: "select",
        options: ["Online", "Offline"]
      }
    ]
  },

  // Age Limit Details
  {
    id: genId(),
    title: "Age Limit Details",
    rows: [
      {
        id: genId(),
        key: "Age_Limit",
        value: "",
        type: "text"
      },
      {
        id: genId(),
        key: "Age_Limit_Cutoff_Date",
        value: "",
        type: "date"
      },
      {
        id: genId(),
        key: "Age_Relaxation",
        value: "",
        type: "text"
      }
    ]
  },

  // Selection Process
  {
    id: genId(),
    title: "Selection Process",
    rows: [
      {
        id: genId(),
        key: "Process",
        value: "",
        type: "text"
      }
    ]
  },

  // Pay Scale
  {
    id: genId(),
    title: "Pay Scale Salary Details",
    rows: [
      {
        id: genId(),
        key: "Salary_Details",
        value: "",
        type: "text"
      }
    ]
  },

  // Total Posts & Qualification
  {
    id: genId(),
    title: "Total Posts and Qualifications",
    rows: [
      {
        id: genId(),
        key: "Post_Name",
        value: "",
        type: "text"
      },
      {
        id: genId(),
        key: "Total_Posts_Qualifications",
        value: "",
        type: "text"
      }
    ]
  },

  // Category-wise Vacancies
  {
    id: genId(),
    title: "Category-wise Vacancies",
    rows: [
      {
        id: genId(),
        key: "General",
        value: "",
        type: "number"
      },
      {
        id: genId(),
        key: "OBC",
        value: "",
        type: "number"
      },
      {
        id: genId(),
        key: "SC",
        value: "",
        type: "number"
      },
      {
        id: genId(),
        key: "ST",
        value: "",
        type: "number"
      },
      {
        id: genId(),
        key: "PWD",
        value: "",
        type: "number"
      }
    ]
  },

  // Exam Pattern
  {
    id: genId(),
    title: "Exam Pattern",
    rows: [
      {
        id: genId(),
        key: "Pattern",
        value: "",
        type: "textarea"
      }
    ]
  },

  // Important Links
  {
    id: genId(),
    title: "Important Links",
    rows: [
      {
        id: genId(),
        key: "Apply_Online",
        value: "",
        type: "url"
      },
      {
        id: genId(),
        key: "Full_Notification",
        value: "",
        type: "url"
      },
      {
        id: genId(),
        key: "Official_Website",
        value: "",
        type: "url"
      }
    ]
  }
];

export default function AdminDynamicEntry() {
  const [postName, setPostName] = useState("");

  // ⭐ NEW ADDED FIELDS
  const [postDate, setPostDate] = useState("");
  const [organization, setOrganization] = useState("");
  const [totalVacancies, setTotalVacancies] = useState("");
  const [payScale, setPayScale] = useState("");
  const [appStartDate, setAppStartDate] = useState("");
  const [appLastDate, setAppLastDate] = useState("");

  const [notificationPdf, setNotificationPdf] = useState("");

  const [sections, setSections] = useState(defaultSections);
  // const [vacancyRows, setVacancyRows] = useState([
  //   { id: genId(), category: "UR", count: "" }
  // ]);

  const [msg, setMsg] = useState("");

  // --------------------- BUILD JSON ---------------------------
  const buildJson = () => {
    const json = {
      // ⭐ NEW FIELDS INCLUDED
      post_name: postName,
      post_date: postDate,
      organization: organization,
      total_vacancies: totalVacancies,
      pay_scale: payScale,
      application_start_date: appStartDate,
      application_last_date: appLastDate,

      notification_pdf: notificationPdf,
      sections: {},
      // vacancy_breakup: []
    };

    // Sections
    for (const s of sections) {
      const sec = {};
      for (const r of s.rows) {
        sec[r.key || r.id] = r.value;
      }
      json.sections[s.title] = sec;
    }

    // Vacancy Breakup
    // for (const v of vacancyRows) {
    //   json.vacancy_breakup.push({
    //     category: v.category,
    //     count: v.count
    //   });
    // }

    return json;
  };

  // --------------------- SECTION FUNCTIONS ---------------------
  const addSection = () =>
    setSections(prev => [
      ...prev,
      {
        id: genId(),
        title: "New Section",
        rows: [{ id: genId(), key: "key1", value: "" }]
      }
    ]);

  const removeSection = id =>
    setSections(prev => prev.filter(sec => sec.id !== id));

  const addRow = sectionId =>
    setSections(prev =>
      prev.map(sec =>
        sec.id === sectionId
          ? {
            ...sec,
            rows: [...sec.rows, { id: genId(), key: "", value: "" }]
          }
          : sec
      )
    );

  const removeRow = (sectionId, rowId) =>
    setSections(prev =>
      prev.map(sec =>
        sec.id === sectionId
          ? { ...sec, rows: sec.rows.filter(r => r.id !== rowId) }
          : sec
      )
    );

  const updateRow = (sectionId, rowId, field, value) =>
    setSections(prev =>
      prev.map(sec =>
        sec.id === sectionId
          ? {
            ...sec,
            rows: sec.rows.map(r =>
              r.id === rowId ? { ...r, [field]: value } : r
            )
          }
          : sec
      )
    );

  // --------------------- VACANCY FUNCTIONS ---------------------
  // const addVacRow = () =>
  //   setVacancyRows(prev => [
  //     ...prev,
  //     { id: genId(), category: "", count: "" }
  //   ]);

  // const updateVacRow = (id, field, value) =>
  //   setVacancyRows(prev =>
  //     prev.map(row =>
  //       row.id === id ? { ...row, [field]: value } : row
  //     )
  //   );

  // const removeVacRow = id =>
  //   setVacancyRows(prev => prev.filter(row => row.id !== id));

  // --------------------- SUBMIT TO BACKEND ---------------------
  const handleSubmit = async () => {
    try {
      const userEmail = localStorage.getItem("userEmail");
      const user_mobileno = localStorage.getItem("user_mobileno");

      if (!userEmail || !user_mobileno) {
        alert("Login details missing. Please login again.");
        return;
      }

      const payload = {
        ...buildJson(),
        //userEmail: userEmail,
        user_mobileno: user_mobileno
      };

      console.log("SUBMIT PAYLOAD:", payload);
      const response = await fetch(
        `${API_BASE_URL}/api/entry/submit`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const data = await response.json();

      if (data.success) {
        alert("Data inserted successfully!");
        setMsg("Data inserted successfully!");
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      alert("Network Error: " + err.message);
    }
  };

  // --------------------- UI ---------------------
  return (
    <div>
      <AdminHeader />

      <main
        style={{
          padding: 20,
          marginTop: 72,
          display: "grid",
          gridTemplateColumns: "1fr 380px",
          gap: 16
        }}
      >
        {/* LEFT SIDE */}
        <section>
          <h2>Latest Job Entry</h2>

          {/* ⭐ NEW INPUT FIELDS START */}
          <label>Post Date</label>
          <input
            type="date"
            value={postDate}
            onChange={e => setPostDate(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Organization</label>
          <input
            value={organization}
            onChange={e => setOrganization(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Total Vacancies</label>
          <input
            value={totalVacancies}
            onChange={e => setTotalVacancies(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Pay Scale</label>
          <input
            value={payScale}
            onChange={e => setPayScale(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Application Start Date</label>
          <input
            type="date"
            value={appStartDate}
            onChange={e => setAppStartDate(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Application Last Date</label>
          <input
            type="date"
            value={appLastDate}
            onChange={e => setAppLastDate(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />
          {/* ⭐ NEW INPUT FIELDS END */}

          <label>Post Name</label>
          <input
            value={postName}
            onChange={e => setPostName(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Notification PDF / Image</label>
          <input
            type="text"
            placeholder="Enter Notification PDF URL"
            value={notificationPdf}
            onChange={(e) => setNotificationPdf(e.target.value)}
          />


          {/* SECTIONS UI — unchanged */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <h3>Sections</h3>
            <button onClick={addSection}>+ Add Section</button>
          </div>

          {/* Sections Render */}
          {sections.map(s => (
            <div
              key={s.id}
              style={{
                border: "1px solid #ddd",
                padding: 10,
                marginBottom: 10,
                background: "#fff"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <input
                  value={s.title}
                  onChange={e =>
                    setSections(prev =>
                      prev.map(x =>
                        x.id === s.id ? { ...x, title: e.target.value } : x
                      )
                    )
                  }
                  style={{ fontWeight: "bold" }}
                />
                <div>
                  <button
                    onClick={() => addRow(s.id)}
                    style={{ marginRight: 8 }}
                  >
                    + Row
                  </button>
                  <button
                    onClick={() => removeSection(s.id)}
                    style={{ color: "red" }}
                  >
                    Remove
                  </button>
                </div>
              </div>

              {/* Rows */}
              {/* Rows */}
              <div style={{ marginTop: 8 }}>
                {s.rows.map(r => (
                  <div
                    key={r.id}
                    style={{
                      display: "flex",
                      gap: 8,
                      marginBottom: 8,
                      alignItems: "center"
                    }}
                  >
                    {/* Field Name */}
                    <input
                      placeholder="Field Name"
                      value={r.key}
                      onChange={e =>
                        updateRow(s.id, r.id, "key", e.target.value)
                      }
                      style={{
                        width: "35%",
                        padding: 8,
                        borderRadius: 4,
                        border: "1px solid #ccc"
                      }}
                    />

                    {/* Field Value */}
                    <div style={{ width: "50%" }}>
                      {r.type === "date" && (
                        <input
                          type="date"
                          value={r.value}
                          onChange={e =>
                            updateRow(s.id, r.id, "value", e.target.value)
                          }
                          style={{
                            width: "100%",
                            padding: 8,
                            borderRadius: 4
                          }}
                        />
                      )}

                      {r.type === "number" && (
                        <input
                          type="number"
                          value={r.value}
                          onChange={e =>
                            updateRow(s.id, r.id, "value", e.target.value)
                          }
                          style={{
                            width: "100%",
                            padding: 8,
                            borderRadius: 4
                          }}
                        />
                      )}

                      {r.type === "url" && (
                        <input
                          type="url"
                          placeholder="https://"
                          value={r.value}
                          onChange={e =>
                            updateRow(s.id, r.id, "value", e.target.value)
                          }
                          style={{
                            width: "100%",
                            padding: 8,
                            borderRadius: 4
                          }}
                        />
                      )}

                      {r.type === "textarea" && (
                        <textarea
                          rows={3}
                          value={r.value}
                          onChange={e =>
                            updateRow(s.id, r.id, "value", e.target.value)
                          }
                          style={{
                            width: "100%",
                            padding: 8,
                            borderRadius: 4,
                            resize: "vertical"
                          }}
                        />
                      )}

                      {r.type === "select" && (
                        <select
                          value={r.value}
                          onChange={e =>
                            updateRow(s.id, r.id, "value", e.target.value)
                          }
                          style={{
                            width: "100%",
                            padding: 8,
                            borderRadius: 4
                          }}
                        >
                          {r.options?.map(opt => (
                            <option key={opt} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </select>
                      )}

                      {(!r.type || r.type === "text") && (
                        <input
                          type="text"
                          value={r.value}
                          onChange={e =>
                            updateRow(s.id, r.id, "value", e.target.value)
                          }
                          style={{
                            width: "100%",
                            padding: 8,
                            borderRadius: 4
                          }}
                        />
                      )}
                    </div>

                    {/* Type Badge */}
                    <span
                      style={{
                        minWidth: 75,
                        textAlign: "center",
                        background: "#eef5ff",
                        color: "#0d6efd",
                        padding: "5px 8px",
                        borderRadius: 5,
                        fontSize: 12,
                        fontWeight: 600
                      }}
                    >
                      {r.type || "text"}
                    </span>

                    {/* Remove Row */}
                    <button
                      onClick={() => removeRow(s.id, r.id)}
                      style={{
                        background: "#dc3545",
                        color: "#fff",
                        border: "none",
                        padding: "6px 10px",
                        borderRadius: 4,
                        cursor: "pointer"
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Vacancy Breakup */}
          {/* <div style={{ border: "1px solid #ddd", padding: 10, background: "#fff" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <strong>Vacancy Breakup</strong>
              <button onClick={addVacRow}>+ Add</button>
            </div>

            <div style={{ marginTop: 8 }}>
              {vacancyRows.map(v => (
                <div
                  key={v.id}
                  style={{ display: "flex", gap: 8, marginBottom: 6 }}
                >
                  <input
                    placeholder="Category"
                    value={v.category}
                    onChange={e =>
                      updateVacRow(v.id, "category", e.target.value)
                    }
                    style={{ width: "60%", padding: 6 }}
                  />
                  <input
                    placeholder="Count"
                    value={v.count}
                    onChange={e =>
                      updateVacRow(v.id, "count", e.target.value)
                    }
                    style={{ width: "30%", padding: 6 }}
                  />
                  <button
                    onClick={() => removeVacRow(v.id)}
                    style={{ color: "red" }}
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
          </div> */}

          {/* Buttons */}
          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <button onClick={handleSubmit}>Submit to Database</button>

            <button
              onClick={() => {
                setSections(defaultSections);
                // setVacancyRows([{ id: genId(), category: "UR", count: "" }]);
                setPostName("");
                setPostDate("");
                setOrganization("");
                setTotalVacancies("");
                setPayScale("");
                setAppStartDate("");
                setAppLastDate("");

                setNotificationPdf("");
                setMsg("");
              }}
            >
              Reset
            </button>
          </div>

          {msg && <div style={{ marginTop: 10 }}>{msg}</div>}
        </section>

        {/* RIGHT SIDE */}
        <aside>
          <h3>JSON Preview</h3>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              background: "#111",
              color: "#b7f5d7",
              padding: 12,
              borderRadius: 6,
              height: "60vh",
              overflow: "auto"
            }}
          >
            {JSON.stringify(buildJson(), null, 2)}
          </pre>

          <h3>Notification Preview</h3>
          {/*<div
            style={{
              border: "1px solid #ddd",
              padding: 8,
              borderRadius: 6,
              background: "#fff"
            }}
          >
            <img
              src={notificationPdf}
              alt="notification"
              style={{ width: "100%", objectFit: "contain" }}
            />
            <div style={{ fontSize: 12, color: "#666", marginTop: 6 }}>
              {notificationPdf}
            </div>
          </div> */}
        </aside>
      </main>
    </div>
  );
}

